<template lang="pug">
  model-form(
        ref="form"
        reset-text="limpiar"
        submit-text="Continuar"
        title="Modificar Precio Venta"
        :fields="formFields"
        v-model="formData"
        @reset="resetForm"
        @submit="submit"
        )
    div(slot="topSlot")
      v-alert.ml-4.mr-4(
        v-show="formData.branch_office_id === 0"
        type="info" 
        :value="true"
      ) 
        | SUCURSAL: TODAS ( SOLO MUESTRA PRECIOS DE VENTA IGUALES EN TODAS LAS SUCURSALES ) 
</template>

<script>
import { ModelForm } from '@/components/reusable_components/next'
/* services */
import BranchOfficeService from '@/services/api/branchOffice'
import ProductService from '@/services/api/product'
/* fields */
import Fields from './fields'

/* vuex */
import {mapState, mapActions} from 'vuex'

export default {
  name: 'modify-sale-price',
  // props: {},
  data: function(){
    return {
      formFields:null,
      formData:{
        price_sale_selected:[],
        branch_office_id:null,
      },
      branchAll :[],
      
    }
  },
  computed: {
    ...mapState('AuthModule',[
      'user'
    ]),
    /*
     */
    ...mapState('SnackbarModalModule', {
      responseConfirm: 'responseConfirm',
    }),
  },
  methods: {
    // -- UI Modification
    // -- Data fetching
    // -- Data handling and transformations
    // -- Validations and Error handling
    submit(){
      if(this.formData.branch_office_id !==0){
        this.$refs.form.setWait(true).then(this.sendSubmit)
      }
      else{
        this.showUpdateAllBranchOfficeSnackbar()
      }
    },
    sendSubmit(){
      const g_branch_office_id = this.formData.branch_office_id
      const products = this.getFormatProductPayload()
      let payload = {
                g_branch_office_id,
                products,
            }
      let arrPromises = []
      if(g_branch_office_id === 0){
        for(let i = 1; i< this.branchAll.length; i++){
          let newPayload = {
            g_branch_office_id: this.branchAll[i].id,
            products : products
          }
          arrPromises.push(ProductService.massiveUpdateSalePrices( newPayload ))
        }
      }
      else{
        arrPromises.push(ProductService.massiveUpdateSalePrices( payload ))
      }
      // // //
      Promise.all(arrPromises).then(r=>{
        console.log(r)
        this.$refs.form.setWait(false)
        console.log(r,'response')
        //this.setMessageConfirmSnack('Confirmar')
        if (r.shift().status === 'error') {
         this.$refs.form.setWait(false)
          this.setSnackbar({
            type: 'error',
            title: 'Error',
            message: 'Error al actualizar precios de venta.',
            timeout: 3000,
          })
        } else {
          this.setSnackbar({
            type: 'success',
            title: 'Éxito',
            message: 'Precios de venta actualizados.',
            timeout: 3000,
          })
          this.$refs.form.getInput('price_sale_selected').refresh()
          this.$refs.form.getInput('price_sale_selected').selected = []
        }
      })
      .catch(e=>{
         this.$refs.form.setWait(false)
        this.setSnackbar({
          type: 'error',
          title: 'Error',
          message: 'Error al actualizar precios de venta.',
          timeout: 3000,
        })
      })
      // arrPromises.push(ProductService.massiveUpdateSalePrices( payload ))
      
    },
    getFormatProductPayload(){
      let productsSelected = this.$refs.form.getInput('price_sale_selected').selected
      let productWithPrice = productsSelected.filter( p => p.new_sale_price ).map( r => {
        let payload = {}
        payload.gains_margin = this.getMargin(r.new_sale_price, this.getCostPrice(r.branch_offices))*100
        payload.sale_price = r.new_sale_price
        payload.wh_product_id = r.id
        return payload
      })
      return productWithPrice
    },
    /* 
    */
    getMargin(salePrice, costPrice){
      let netPrice = salePrice / 1.19
      let margin = (netPrice - costPrice) / costPrice
      return margin
    },
    /*
     */
    getCostPrice(branchOffice){
      // Todas
      if(this.formData.branch_office_id === 0){
        return branchOffice[0].cost_price
      }
      // select branchOffice 
      for(let i =0 ; i < branchOffice.length; i++){
        if( branchOffice[i].g_branch_office_id === this.formData.branch_office_id ){
          return branchOffice[i].cost_price
        }
      }
    },
    refreshFields() {
      console.log(this.formData)
      this.formFields = Fields(this.branchAll,this.formData.branch_office_id)
      this.formFields[1].props.attachParams.g_branch_office_id = this.formData.branch_office_id 
    },
    showUpdateAllBranchOfficeSnackbar () {
      //
      this.resetSnackbarState()
      this.showSnackbar( 'warning', '¿Actualizar precios en todas las sucursales?', '', () => this.setMessageConfirmSnack( 'Actualizar precios' ) )
      //
    },
    async showSnackbar ( type, title, message, callback = () => {} ) {
      //
      this.resetSnackbarState()
      this.initSnackbar( this.fillSnack( type, title, message, false,  ) ); callback()
    },
    // -- Other functions
    // -- Vuex mappings
    ...mapActions('SnackbarModalModule', {
        initSnackbar: 'initSnackbar',
        setSnackbar: 'setSnackbar',
        resetSnackbarState: 'resetSnackbarState',
        setMessageConfirmSnack: 'setMessageConfirmSnack',
    }),
    ...mapActions('MenuesModule', {
      setTitleTopBar: 'setTitleTopBar',
    }),
  },
  watch: {
    formData:{
      handler(val){
        console.log(val,'handler')
        
        this.refreshFields()
        //this.formFields[1].props.attachParams.g_branch_office_id = val.branch_office_id 
        //this.$refs.form.$forceUpdate()
        //this.$refs.form.getInput('price_sale_selected').refresh()
      },
      deep:true,
    },
    async responseConfirm ( message ) {
      switch ( message ) {
          case 'Actualizar precios': return this.sendSubmit()
      }
    },
  },
  components: {
    'model-form': ModelForm,
  },
  // mixins: [],
  // filters: {},
  // -- Lifecycle Methods
    beforeMount: async function() {
        
    let branch = await BranchOfficeService.fetchAll()
    //   ///this.officeList = 
    // this.formData.branch_office_id.items = branch
    let auxBranch = [
      {id:0, name: 'Todas'},
      ...branch
    ]
    this.branchAll = auxBranch
    this.formFields = Fields(auxBranch,this.user.hr_employee.g_branch_office_id)
    this.formData.branch_office_id = this.user.hr_employee.g_branch_office_id
    
    this.setTitleTopBar("Modificación Precios Ventas")
  },
  // -- End Lifecycle Methods
}
</script>

<style lang="scss">
  
</style>